<template>
    <div :class="classMainBlock">
        <label :for="id">
            {{ title }}
        </label>
        <date-range-picker
            id="filter_dates"
            ref="picker"
            v-model="itemModel"
            :locale-data="localeData"
            :ranges="false"
            :time-picker24-hour="false"
            opens="right"
            @update="change"
        >
            <template #input>
                <input
                    :value="getValue()"
                    class="date-range-picker-input"
                    @input="changeItemModel"
                />
            </template>
        </date-range-picker>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: '',
        },
        id: {
            type: String,
            default: '',
        },
        classMainBlock: {
            type: String,
            default: '',
        },
        start: {
            type: String,
            default: '',
        },
        end: {
            type: String,
            default: '',
        },
    },
    data: function () {
        return {
            itemModel: {},
            itemValue: null,
            localeData: {
                format: 'yyyy-mm-dd',
                firstDay: 0,
            },
        };
    },
    watch: {
        start: function () {
            this.init();
        },
        end: function () {
            this.init();
        },
    },
    mounted() {
        this.init();
    },
    methods: {
        validateManualValue(startDate, endDate) {
            return startDate.isValid() && endDate.isValid() && startDate <= endDate;
        },
        changeItemModel(event) {
            let value = event.target.value.split(' - ');
            let startDate = value[0] ? value[0].replace(' ', '') : '';
            let endDate = value[1] ? value[1].replace(' ', '') : '';
            startDate = window.moment(startDate, 'YYYY-MM-DD', true);
            endDate = window.moment(endDate, 'YYYY-MM-DD', true);
            this.validateManualValue(startDate, endDate) && this.setModel(startDate, endDate);
            this.change();
        },
        init() {
            let startDate = this.start ? window.moment(this.start, 'YYYY-MM-DD') : window.moment(),
                endDate = this.end ? window.moment(this.end, 'YYYY-MM-DD') : window.moment();
            this.setModel(startDate, endDate);
            this.setValue();
        },
        convertByFormat(value) {
            return value ? window.moment(value.toISOString()).format('YYYY-MM-DD') : '';
        },
        change() {
            this.setValue();
            this.$emit('change', this.getValue());
        },
        getValue() {
            return this.itemValue;
        },
        setModel(startDate, endDate) {
            this.itemModel = {
                startDate,
                endDate,
            };
        },
        setValue() {
            this.itemValue =
                this.itemModel.startDate && this.itemModel.endDate
                    ? this.convertByFormat(this.itemModel.startDate) + ' - ' + this.convertByFormat(this.itemModel.endDate)
                    : null;
        },
        clear() {
            this.itemModel = {};
            this.itemValue = null;
        },
    },
};
</script>
